import axios from './../plugins/private-api-axios'

export const journeyService = {
    urlPrefix: '/journeys',
    config: {
        headers: {
            Authorization: ''
        }
    },
    async getJourney (vehicleId) {
        try {
            return await axios.get(`${this.urlPrefix}/${vehicleId}`, this.config)
        } catch (e) {
            throw e
        }
    },
    async getHistoricalJourney (vehicleId, journeyId, date) {
        try {
            return await axios.get(`${this.urlPrefix}/${journeyId}/${vehicleId}/${date}`, this.config)
        } catch (e) {
            throw e
        }
    },
    async getJourneys (vehicleId, dateFrom, dateTo = null) {
        let urlBuilder = {
            'VehicleId': vehicleId,
            'DateFrom': dateFrom
        }

        if (null !== dateTo) {
            urlBuilder.dateTo = dateTo
        }

        try {
            return await axios.get(`${this.urlPrefix}?${new URLSearchParams(urlBuilder).toString()}`, this.config)
        } catch (e) {
            throw e
        }
    }
}

export const updateJourneyService = (accessToken) => {
    journeyService.config.headers.Authorization = accessToken
}

export default journeyService
